module.exports = __webpack_public_path__ + "img/Screen Shot 2020-10-26 at 3.39.48 PM@2x.91a37a6e.png";